const REGISTRY = {};

function pubsub(target)
{

	target.register = function(id, catalog = 'default')
	{
		if (!REGISTRY[catalog])
			REGISTRY[catalog] = [];
		let index = REGISTRY[catalog].findIndex(member => member.id == id);
		if (index < 0)
			index = REGISTRY[catalog].length;
		REGISTRY[catalog][index] = { 'id': id, 'member': this };
	};

	target.locate = function(id, catalog = 'default')
	{
		return REGISTRY[catalog].find(member => new RegExp(`\\b${id}\\b`).test(member.id))?.member;
	};

	target.subscribe = function(events_array, callback, once = true)
	{
		if (typeof callback != 'function')
			throw new Error('Callback must be a function');
		events_array.forEach(ev =>
		{
			if (!Object.hasOwn(this, 'subscribers'))
				this.subscribers = {};
			if (!this.subscribers[ev])
				this.subscribers[ev] = [];
			if (!this.subscribers[ev].find(subscriber => subscriber.callback == callback))
				this.subscribers[ev].push({ callback: callback, once: once });
		});
	};

	target.unsubscribe = function(events_array, callback)
	{
		events_array.forEach(ev =>
		{
			if (Object.hasOwn(this, 'subscribers') && this.subscribers[ev])
			{
				this.subscribers[ev].find((entry, index, array) =>
				{
					if (entry.callback == callback)
						array.splice(index, 1);
				});
			}
		});
	};

	target.publish = function(event_name, ...args)
	{
		for (let index = 0; this.subscribers?.[event_name] && index < this.subscribers[event_name].length; )	// length may change because of splice() inside the loop
		{
			let entry = this.subscribers[event_name][index];
			setTimeout(() => entry.callback(event_name, this, ...args), 0);
			if (entry.once)
				this.subscribers[event_name].splice(index, 1);
			else
				index++;
		}
	};

	return target;

}

export default pubsub;

